<template>
  <v-dialog
    v-model="value"
    max-width="400"
    persistent
  >
    <v-card>
      <v-card-title class="headline">
        Restore Contract
      </v-card-title>

      <v-card-text>
        Are you sure you want to restore
        <strong>{{ contract.contractNumber }}</strong>?
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn text @click="confirm">Restore</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmRestoreDialog',

  // Vue 2's default v-model uses `value` + `input`
  props: {
    contract: { type: Object, required: true },
    value:    { type: Boolean, default: false }
  },

  methods: {
    close() {
      this.$emit('input', false)
    },
    confirm() {
      this.$emit('confirmed')
      this.$emit('input', false)
    }
  }
}
</script>